<div class="spinner-container">
  <div class="loader">
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
  </div>

  <span class="loader-text">{{loader_message()}}</span>
</div>
